import { Input, OnInit, Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { of, tap, catchError, finalize } from 'rxjs';

import { AlertsService } from '@tablesready/frontend-alerts-bar';
import { AccountApiService } from '@tablesready/frontend-store';

@Component({
  selector: 'tablesready-admin-apply-discount-code',
  templateUrl: './apply-discount-code.component.html',
  styleUrls: ['./apply-discount-code.component.scss'],
})
export class ApplyDiscountCodeComponent implements OnInit {
  @Input() coupon: string;

  form: FormGroup;
  inProgress = false;
  setNewCoupon = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly accountApiService: AccountApiService,
    private readonly alertsService: AlertsService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      coupon: ['', [Validators.required]],
    });
  }

  editCoupon(): void {
    this.setNewCoupon = true;
  }

  apply(): void {
    this.inProgress = true;
    const { coupon } = this.form.value;

    this.accountApiService.applyCoupon({ coupon })
      .pipe(
        tap(() => this.alertsService.addSuccess('coupon code successfully applied!', 'Success: ')),
        catchError(() => {
          this.alertsService.addError('an error occurred during applying coupon code.');

          return of(null);
        }),
        finalize(() => {
          this.setNewCoupon = false;
          this.inProgress = false;
        }),
      )
      .subscribe();
  }

  get couponControl(): AbstractControl {
    return this.form.get('coupon');
  }
}
